var exports = {
  "TQ": "Checkbox.module__checkboxWrapper___YndURm",
  "r9": "Checkbox.module__disabled___YndURm",
  "iD": "Checkbox.module__menuDisabled___YndURm",
  "kv": "Checkbox.module__checkbox___YndURm",
  "aP": "Checkbox.module__box___YndURm",
  "LI": "Checkbox.module__round___YndURm",
  "KD": "Checkbox.module__checked___YndURm",
  "oE": "Checkbox.module__checkIcon___YndURm",
  "Pf": "Checkbox.module__label___YndURm",
  "hJ": "Checkbox.module__labelInteractive___YndURm",
  "QK": "Checkbox.module__labelText___YndURm",
  "P8": "Checkbox.module__menuChecked___YndURm",
  "fb": "Checkbox.module__checkboxIndicator___YndURm",
};

module.exports = exports;
